import { put, takeLeading } from 'redux-saga/effects';

import { Routes } from 'constants/routes';

import * as $app from 'modules/app';
import * as $nav from 'modules/navigation';
import * as actions from '../actions';

const signout = function* () {
  yield put($app.reset());
  yield put($nav.navigate(Routes.Signin));
};

export const signoutSaga = function* () {
  yield takeLeading(actions.signout, signout);
};
